import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'titleCaseCustom'
})
export class TitleCaseCustomPipe implements PipeTransform {

  transform(value: any, ...args: any[]): any {
    return value.replace('-', ' ').replace('_', ' ')
  }

}
